/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Job } from '../../types/processing-schemas.ts';
import React from 'react';
import { Tag } from 'primereact/tag';
import { statusColors } from '../TableHeader.tsx';
import { useTranslation } from 'react-i18next';

interface Props {
  status: Job['status'];
}
export const StatusRender: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <div className="flex align-items-center">
      <Tag
        style={{ backgroundColor: statusColors[status], color: 'var(--primary-color-text)' }}
        value={t([`jobs.properties.status.${status}`, status])}
      />
    </div>
  );
};
